<template lang='pug'>
  v-col(sm='12')
    v-row(no-gutters)
      v-col(style='padding: 0 20px')
        md-card
          md-card-header.md-card-header-icon.md-card-header-green
            .card-icon
              md-icon settings
            h4.title
              | {{ $t("webChannel.Auth-Magento.title") }}
          md-card-content
            form.form-horizontal(action method='post')
              .md-layout
                .md-layout-item.md-size-50(style='padding-left: 0')
                 .md-layout-item.md-size-50(style='padding-left: 0')
                md-field(style='margin-top: 30px;')
                  label
                    | {{
                    | $t(
                    | "webChannel.Auth-Magento.subitems.magentoEndpoint"
                    | )
                    | }}
                  md-textarea(v-model='canalWebData.magentoEndpoint' md-autogrow)
                md-field(style='margin-top: 30px;')
                  label
                    | {{
                    | $t(
                    | "webChannel.Auth-Magento.subitems.magentoBearerToken"
                    | )
                    | }}
                  md-textarea(v-model='canalWebData.magentoBearerToken' md-autogrow)
</template>

<script>
export default {
  props: {
    canalWebData: {
      type: Object,
      required: true
    }
  }
}
</script>
